import React, { Component } from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  Accordion,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import data from './faq.json';
import CookieBlockedIframe from '../../components/CookieBlockedIframe/CookieBlockedIframe';
import css from './FAQPage.module.css';
import { ButtonTabNavHorizontal } from '../../components/TabNavHorizontal/TabNavHorizontal';

export class FAQPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // keep track of which FAQ tab to show in desktop viewport
      isBSL: false,
      isText: true,
    };
  }

  showBSLFAQ = () => {
    this.setState({
      isBSL: true,
      isText: false,
    });
  };

  showTextFAQ = () => {
    this.setState({
      isText: true,
      isBSL: false,
    });
  };

  render() {
    const buttonTabs = [
      { text: 'Text', onClick: this.showTextFAQ, selected: this.state.isText },
      { text: 'BSL', onClick: this.showBSLFAQ, selected: this.state.isBSL },
    ];

    return (
      <StaticPage
        title="Frequently Asked Questions"
        schema={{
          '@context': 'http://schema.org',
          '@type': 'FAQPage',
          description: 'Signalise - Frequently Asked Questions.',
          name: 'Frequently Asked Questions',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'Question 1?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Answer: Lorem ipsum',
              },
            },
          ],
        }}
      >
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer />
          </LayoutWrapperTopbar>

          <LayoutWrapperMain className={css.mainWrapper}>
            <h1>Frequently Asked Questions</h1>
            <h2>
              If you want to know more about Signalise or co-operatives in general, you can find
              information below.
            </h2>

            <ButtonTabNavHorizontal
              eventKey="text"
              title="English"
              tabs={buttonTabs}
              id="controlled-tab-example"
              className={css.tab}
            />

            {this.state.isText ? (
              <Accordion allowMultipleOpen className={css.accordion}>
                {data.map(post => (
                  <div key={post.id.toString()} label={post.title}>
                    <p
                      className={css.cardContent}
                      dangerouslySetInnerHTML={{ __html: post.content }}
                    />
                  </div>
                ))}
              </Accordion>
            ) : (
              <Accordion allowMultipleOpen>
                {data.map(post => (
                  <div
                    key={post.id.toString()}
                    className={css.label}
                    label={post.title}
                  >
                    <div className={css.videoWrapper}>
                      <CookieBlockedIframe
                        src={`${post.video}?rel=0&amp;autoplay=1&amp;origin=https://btea.signalise.coop`}
                        className={css.reactPlayer}
                      />
                    </div>
                  </div>
                ))}
              </Accordion>
            )}
          </LayoutWrapperMain>

          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </StaticPage>
    );
  }
}

export default FAQPage;
